export default {
  book_now: 'Book nu',
  minimum_age: 'Kun over {age}',
  excess_liability: 'Selvrisiko',
  security_deposit: 'Depositum',
  fuel_policy: 'Benzinpolitik',
  like_for_like: 'Identisk erstatning',
  full_to_full: 'Fuld til fuld',
  miles_per_rental: '{mileage} gratis miles pr. udlejning',
  km_per_rental: '{mileage} gratis kilometer pr. udlejning',
  unlimited_mileage: 'Ubegrænsede miles',
  unlimited_mileage_km: 'Ubegrænsede km',
  non_amendable: 'Ikke-ændringsberettiget',
  non_refundable: 'Ikke-refusionsberettiget',
  free_cancellation_until: 'Gratis annullering indtil',
  cancellation_in_line_with: 'Annullering i overensstemmelse med',
  tcs: 'T&amp;C',
  free_extras_on_collection: 'To gratis ekstra ved afhentning',
  glass_and_tyres_covered: 'Glas og dæk dækkes',
  number_of_passengers: 'Antal passagerer',
  number_of_bags: 'Antal tasker',
  fuel_type: 'Benzintype',
  co2: 'CO2',
  aircon: 'Aircondition',
  transmission: 'Gear',
  book_type: 'Book {type}',
  debit_card_deposit: 'Debetkort accepteret for indbetalinger',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/da/quotes/price_card.js